import React, { useEffect, useState } from 'react';
import { FileCheck } from 'lucide-react';
export function StickyMobileCTA() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (400px)
      const pastHero = window.scrollY > 400;
      // Hide when near the main CTA section
      const ctaSection = document.getElementById('contact');
      let nearCTA = false;
      if (ctaSection) {
        const rect = ctaSection.getBoundingClientRect();
        nearCTA = rect.top < window.innerHeight + 100;
      }
      setVisible(pastHero && !nearCTA);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-0 left-0 right-0 z-40 lg:hidden" role="complementary" aria-label="Quick contact" data-id="element-432">
      <div className="bg-white/95 backdrop-blur-sm border-t border-warm-200 px-5 py-3 shadow-lg" data-id="element-433">
        <a href="/contact" className="btn-primary w-full text-center" data-id="element-434">
          <FileCheck className="mr-2 h-5 w-5" data-id="element-435" />
          Request a Report
        </a>
      </div>
    </div>;
}